import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { EventEmitter } from '@angular/core';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbdModalContent } from '../../alert-component';
import * as Parse from 'parse';
import { QuizData } from '../QuizData';
import { CookieService } from 'ngx-cookie-service';
import { UserData } from 'src/app/model/UserData';

@Component({
  selector: 'app-sdohquiz2',
  templateUrl: './sdohquiz2.component.html',
  styleUrls: ['./sdohquiz2.component.css']
})
export class Sdohquiz2Component implements OnInit {

  sdohquizForm : FormGroup;
  //@Output() doneSubmiting = new EventEmitter();
  failedMessage : string;
  //activityPlanSaved : boolean;
  submitted = false;
  successMessage: string;
  //activityFailed: boolean;
  //quizDone: boolean;
  //riskScore: string = "";

  /*
  basic_requirements = [];
  current_problems = [];
  */
  primary_member_situation = [];
  related_problems = [];
  counseling = [];


  constructor(
    private router : Router,
    private _bkoffService: BackOffServiceService,
    private modalService: NgbModal,
    private formBuilder : FormBuilder,
    private cookie: CookieService,

  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit(): void {

    this.sdohquizForm  =  this.formBuilder.group({
      /*
      household_member: ['', [Validators.required, Validators.pattern(regexPatterns.household_member)]],
      family_income: ['', [Validators.required, Validators.pattern(regexPatterns.family_income)]],
      basic_requirements: new FormArray([], minSelectedCheckboxes(1)),
      supported_by: ['', Validators.required],
      housing_situation: ['', Validators.required],
      current_problems: new FormArray([], minSelectedCheckboxes(1)),
      work_situation: ['', Validators.required],
      current_work: ['', Validators.required],
      refugee: ['', Validators.required],
      */
      discrimination: ['', Validators.required],
      related_problems: new FormArray([], minSelectedCheckboxes(1)),
      //afraid_of_partner: ['', Validators.required],
      primary_member_situation: new FormArray([], minSelectedCheckboxes(1)),
      //discharged_from_armed_forces: ['', Validators.required],
      counseling: new FormArray([], minSelectedCheckboxes(1)),
      fluent_english: ['', Validators.required],
      understanding_insurance_benifits: ['', Validators.required]

    });

    /*
    this.basic_requirements = this.getBasicRequirements();
    this.addBasicRequirementsCheckboxes();

    this.current_problems = this.getCurrentProblems();
    this.addCurrentProblemsCheckboxes();
    */

    this.related_problems = this.getRelatedProblems();
    this.addRelatedProblemsCheckboxes();

    this.primary_member_situation = this.getPrimaryMemberSituation();
    this.addPrimaryMemberSituationCheckboxes();

    this.counseling = this.getCounseling();
    this.addCounselingCheckboxes();

    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0)
    });

  }

  /*
  private addBasicRequirementsCheckboxes() {
    this.basic_requirements.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.sdohquizForm.controls.basic_requirements as FormArray).push(control);
    });
  }

  private addCurrentProblemsCheckboxes() {
    this.current_problems.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.sdohquizForm.controls.current_problems as FormArray).push(control);
    });
  }
  */

  private addRelatedProblemsCheckboxes() {
    this.related_problems.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.sdohquizForm.controls.related_problems as FormArray).push(control);
    });
  }

  private addPrimaryMemberSituationCheckboxes() {
    this.primary_member_situation.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.sdohquizForm.controls.primary_member_situation as FormArray).push(control);
    });
  }

  private addCounselingCheckboxes() {
    this.counseling.map((o, i) => {
      const control = new FormControl(); // if first item set to true, else false
      (this.sdohquizForm.controls.counseling as FormArray).push(control);
    });
  }

  get fmBuilder() { return this.sdohquizForm.controls; }

  reset(){
    this.sdohquizForm.reset({PersonalData: new QuizData()});
  }


  getFormControl(name:any) {
    return this.sdohquizForm.get(name);
  }
  //get formTypicalmeal() { return <FormArray>this.sdohquizForm.get('typicalmeals');}

  
  getBasicRequirements(){
    return [
      { value: 1, id: 'food', name: 'Food' },
      { value: 2, id: 'drinkingWater', name: 'Drinking Water' },
      { value: 3, id: 'clothing', name: 'Clothing' },
      { value: 4, id: 'utilities', name: 'Utilities' },
      { value: 5, id: 'transportation', name: 'Transportation' },
      { value: 6, id: 'childcare', name: 'Childcare' },
      { value: 7, id: 'medicine', name: 'Medicine' },
      { value: 8, id: 'accessToHealthCare', name: 'Access to healthcare (medical, dental, mental health, vision)' },
      { value: 9, id: 'medicalInsurance', name: 'Medical Insurance' },
      { value: 10, id: 'phone', name: 'Phone' },
      { value: 11, id: 'welfareSupport', name: 'Welfare Support' },
      { value: 12, id: 'otherBasicRequirements', name: 'Other' }
    ]
  }
  getCurrentProblems(){
    return [
      { value: 1, id: 'bugInfestationOrMould', name: 'Bug infestation and/or mould' },
      { value: 2, id: 'leadPaintOrPipes', name: 'Lead paint or pipes' },
      { value: 3, id: 'inadequateHeatOvenOrstove', name: 'Inadequate heat, oven or stove not working' },
      { value: 4, id: 'notWorkingSmokeDetectors', name: 'No or not working smoke detectors, water leaks' },
      { value: 5, id: 'noneOfTheAbove', name: 'None of the above' } 
    ]
  }
  getRelatedProblems(){
    return [
      
      { value: 1, id: 'incarceration', name: 'Problems related to incarceration' },
      { value: 2, id: 'substanceAbuse', name: 'Problems related to substance abuse' },
      { value: 3, id: 'unsafeNeighborhood', name: 'Problems related to unsafe neighborhood' },
      { value: 4, id: 'notApplicable', name: 'Not applicable' }
      
    ]
  }
  getPrimaryMemberSituation(){
    return [

      { value: 2, id: 'conflictsWithFamilyMembersOnAReqularBasis', name: 'I face conflict with my primary family members on a regular basis' },
      { value: 3, id: 'primaryMemberIsmissing', name: 'My primary family members are missing, in prison, in the military, or have died' },
      { value: 4, id: 'childInWelfareCustody', name: 'I have a child in welfare custody' },
      { value: 5, id: 'iFaceOtherProblems', name: 'I face other problems related to primary family members' },
      { value: 6, id: 'iFaceNoIssuesWithPrimaryMembers', name: 'I face no issues related to my primary family or household members' }

    ]
  }

  getCounseling(){
    return [

      { value: 1, id: 'dietaryCounseling', name: 'Dietary counseling' },
      { value: 2, id: 'tobacoAbuseCounseling', name: 'Tobacco abuse counseling' },
      { value: 3, id: 'exercizeCounseling', name: 'Exercise counseling' },
      { value: 4, id: 'psychologicalCounseling', name: 'Psychological counseling' },
      { value: 5, id: 'iAmNotCounseling', name: 'I am not counseling' },
      { value: 6, id: 'otherCounseling', name: 'Other counseling' }
    ]
  }

  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.sdohquizForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.sdohquizForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }
  
    /*
    submitClick(){

      if (this.sdohquizForm.invalid) {
        const modalRef = this.modalService.open(NgbdModalContent);
        if (this.getFormValidationErrors()){
          modalRef.componentInstance.name = 'You have left a question unanswered';
        }
        else{
          modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
        }
          return;
      }
      this.submitted = true;

      const selectedBasicRequirements = this.sdohquizForm.value.basic_requirements
        .map((v, i) => v ? this.basic_requirements[i].value : null)
        .filter(v => v !== null);
  
      const selectedCurrentProblems = this.sdohquizForm.value.current_problems
        .map((v, i) => v ? this.current_problems[i].value : null)
        .filter(v => v !== null);
  
      const selectedCrimeRecords = this.sdohquizForm.value.crime_records
        .map((v, i) => v ? this.crime_records[i].value : null)
        .filter(v => v !== null);
  
      const selectedPrimaryMemberSituation = this.sdohquizForm.value.primary_member_situation
        .map((v, i) => v ? this.primary_member_situation[i].value : null)
        .filter(v => v !== null);
    
      var sdohQuizData = new QuizData();
      sdohQuizData.basic_requirements = selectedBasicRequirements;
      sdohQuizData.current_problems = selectedCurrentProblems;
      sdohQuizData.crime_records = selectedCrimeRecords;
      sdohQuizData.primary_member_situation = selectedPrimaryMemberSituation;
      sdohQuizData.household_member = Number(this.sdohquizForm.get(['household_member']).value)
      sdohQuizData.family_income = Number(this.sdohquizForm.get(['family_income']).value)
      sdohQuizData.supported_by = String(this.sdohquizForm.get(['supported_by']).value)
      sdohQuizData.housing_situation = String(this.sdohquizForm.get(['housing_situation']).value)
      sdohQuizData.work_situation = String(this.sdohquizForm.get(['work_situation']).value)
      sdohQuizData.current_work = String(this.sdohquizForm.get(['current_work']).value)
      sdohQuizData.refugee = String(this.sdohquizForm.get(['refugee']).value)
      sdohQuizData.discrimination = String(this.sdohquizForm.get(['discrimination']).value)
      sdohQuizData.afraid_of_partner = String(this.sdohquizForm.get(['afraid_of_partner']).value)
      sdohQuizData.discharged_from_armed_forces =  String(this.sdohquizForm.get(['discharged_from_armed_forces']).value)
      sdohQuizData.zip = Number(this.sdohquizForm.get(['zip']).value)
      sdohQuizData.fluent_english = String(this.sdohquizForm.get(['fluent_english']).value)
      sdohQuizData.understanding_insurance_benifits = String(this.sdohquizForm.get(['understanding_insurance_benifits']).value)
    
  
      this._bkoffService.setsdohquiz(sdohQuizData).then((success)=>{
        this.doneSubmiting.emit("saved")
        this.cookie.set("sdohDone", "true");
        this.activityPlanSaved = true;
        this.router.navigateByUrl('/logs');
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.name = 'Your SDOH has been stored';
        modalRef.componentInstance.title = 'Success';
        this._bkoffService.setisSdohQuizDone();
      }).catch(()=>{
       this.failedMessage  = "Error saving SDOH Quiz "
       this.activityFailed = true
       this.sendUserFeedback(this.failedMessage)
       this.doneSubmiting.emit("failed")
       console.log(this.failedMessage)
      });
    }

    */

   btnclick(){
    const result: QuizData = Object.assign({}, this.sdohquizForm.value);
    let fromResult = Object.assign({}, result);
    
    this.submitted = true;

    console.log("about to check form validation");
    // stop here if form is invalid
    if (this.sdohquizForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'You have left a question unanswered';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }

    /*
    const selectedBasicRequirements = this.sdohquizForm.value.basic_requirements
        .map((v, i) => v ? this.basic_requirements[i].value : null)
        .filter(v => v !== null);
  
    const selectedCurrentProblems = this.sdohquizForm.value.current_problems
      .map((v, i) => v ? this.current_problems[i].value : null)
      .filter(v => v !== null);

    */
  
    const selectedRelatedProblems = this.sdohquizForm.value.related_problems
      .map((v, i) => v ? this.related_problems[i].value : null)
      .filter(v => v !== null);
  
    const selectedPrimaryMemberSituation = this.sdohquizForm.value.primary_member_situation
      .map((v, i) => v ? this.primary_member_situation[i].value : null)
      .filter(v => v !== null);

    const selectedCounseling = this.sdohquizForm.value.counseling
      .map((v, i) => v ? this.primary_member_situation[i].value : null)
      .filter(v => v !== null);
    
    var userInfo = new QuizData()

    /*
    userInfo.basic_requirements = selectedBasicRequirements;
    userInfo.current_problems = selectedCurrentProblems;
    */
    userInfo.related_problems = selectedRelatedProblems;
    userInfo.primary_member_situation = selectedPrimaryMemberSituation;
    userInfo.counseling = selectedCounseling;
    /*
    userInfo.household_member = Number(this.sdohquizForm.get(['household_member']).value)
    userInfo.family_income = Number(this.sdohquizForm.get(['family_income']).value)
    userInfo.supported_by = String(this.sdohquizForm.get(['supported_by']).value)
    userInfo.housing_situation = String(this.sdohquizForm.get(['housing_situation']).value)
    userInfo.work_situation = String(this.sdohquizForm.get(['work_situation']).value)
    userInfo.current_work = String(this.sdohquizForm.get(['current_work']).value)
    userInfo.refugee = String(this.sdohquizForm.get(['refugee']).value)
    */
    userInfo.discrimination = String(this.sdohquizForm.get(['discrimination']).value)
    //userInfo.afraid_of_partner = String(this.sdohquizForm.get(['afraid_of_partner']).value)
    //userInfo.discharged_from_armed_forces =  String(this.sdohquizForm.get(['discharged_from_armed_forces']).value)
    //userInfo.zip = Number(this.sdohquizForm.get(['zip']).value)
    userInfo.fluent_english = String(this.sdohquizForm.get(['fluent_english']).value)
    userInfo.understanding_insurance_benifits = String(this.sdohquizForm.get(['understanding_insurance_benifits']).value)
    
    console.log(userInfo.score)
    this._bkoffService.setSdohQuiz2Data(userInfo);

    console.log("btnclick registered")
    this.router.navigateByUrl('/comorbidityquiz');   
  };

}

function minSelectedCheckboxes(min:Number) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}
